<template>
  <SogButton
    v-show="productPrice"
    :tooltip="_tooltip"
    @click="onClick(productPrice)"
  >
    <span v-show="productPrice.isInsurance">{{ productPrice.carTypeName }}<br></span>
    <span v-show="productPrice.isInsurance">{{ productPrice.territoryTypeName ?? productPrice.validityDay }}<br></span>
    {{ productPrice.manufacturerName }}<br>
    <span>
      <!--
      <SogDataLabel
        v-show="!(productPrice.minSaleGrossPrice)&&productPrice.grossPrice>0"
        :value="productPrice.grossPrice"
        :value-type="SogDataLabelValueType.Money"
      />
      <SogDataLabel
        v-show="productPrice.minSaleGrossPrice"
        :value="productPrice.minSaleGrossPrice"
        :value-type="SogDataLabelValueType.Money"
      />
-->
      <SogDataLabel
        v-show="visiblePrice"
        :value="_price"
        :value-type="SogDataLabelValueType.Money"
      />
      <br>
    </span>
    <SogSvgIcon
      v-show="productPrice.isJustInTime"
      :icon="mdiWeb"
    />
    <SogSvgIcon
      v-show="productPrice.isStore"
      :icon="mdiStore"
    />
    <SogSvgIcon
      v-show="productPrice.isStoreExportBlank"
      :icon="mdiFileDocument"
    />
  </SogButton>
</template>

<script setup lang="ts">
import SogButton from "@/shared/ui/SogButton.vue";
import ProductPrice from "@/shared/model/productPrice";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogSvgIcon from "@/shared/ui/SogSvgIcon.vue";
import {mdiFileDocument, mdiStore, mdiWeb} from "@mdi/js";
import {computed} from "vue";

interface Props {
  productPrice: ProductPrice,
  visiblePrice?: boolean
}

const props = withDefaults(defineProps<Props>(), {visiblePrice: true})

const emit = defineEmits<{
  (e: 'click', product: ProductPrice): void
}>()


function onClick(value: ProductPrice) {
  emit("click", value)
}

const _price = computed(() => {
  if (props.productPrice.minSaleGrossPrice)
    return props.productPrice.minSaleGrossPrice
  return props.productPrice.grossPrice > (props.productPrice.minSaleGrossPrice ?? 0) ? props.productPrice.grossPrice : props.productPrice.minSaleGrossPrice
})

const _tooltip = computed(()=>{
  if(props.productPrice.isJustInTime){
    return "Online bestellen";
  }
  if(props.productPrice.isStore){
    return "Aus Lager";
  }
  if(props.productPrice.isStoreExportBlank){
    return "Vorgedruckte Formular";
  }
  return "";
})

</script>

<style>

</style>
